export default "__VITE_ASSET__Dr5yiPGX__"